"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = require("@/utils/validate");
var _api = require("../api");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var SEND_TYPE_OPTIONS = [{
  value: 1,
  label: '测试卡'
}, {
  value: 2,
  label: '体验卡'
}, {
  value: 3,
  label: '内部员工卡'
}, {
  value: 4,
  label: '出单'
}, {
  value: 5,
  label: '赠送'
}, {
  value: 6,
  label: '其他'
}, {
  value: 7,
  label: '客户充值'
}];
var createDefaultForm = function createDefaultForm() {
  return {
    sendTypes: [],
    rechargeAmountThreshold: undefined,
    noticeStatus: 1,
    auditorFeishuUserId: '',
    submitterFeishuUserId: '',
    noticeTime: ''
  };
};
var _default = exports.default = {
  name: 'AuditConfigDialog',
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      submitting: false,
      mode: '',
      sendTypeOptions: SEND_TYPE_OPTIONS,
      form: createDefaultForm(),
      rules: {
        // sendTypes: [
        //   {
        //     type: 'array',
        //     required: true,
        //     min: 1,
        //     message: '请至少选择一种发卡类型',
        //     trigger: 'change'
        //   }
        // ],
        rechargeAmountThreshold: [{
          validator: this.validateRechargeAmount,
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  computed: {
    submitButtonText: function submitButtonText() {
      if (this.mode === 'create') return '创建配置';
      if (this.mode === 'edit') return '保存修改';
      return '保存配置';
    }
  },
  created: function created() {
    this.debouncedSubmit = (0, _validate.Debounce)(this.handleSubmit, 500);
  },
  methods: {
    open: function open() {
      this.dialogVisible = true;
      this.mode = '';
      this.loadConfig();
    },
    loadConfig: function () {
      var _loadConfig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              _context.n = 2;
              return (0, _api.getRechargeAuditConfig)();
            case 2:
              data = _context.v;
              this.mode = data ? 'edit' : 'create';
              this.form = this.mapConfigToForm(data);
              this.$nextTick(function () {
                if (_this.$refs.auditConfigFormRef) {
                  _this.$refs.auditConfigFormRef.clearValidate();
                }
              });
              return _context.a(2, true);
            case 3:
              _context.p = 3;
              _t = _context.v;
              // 请求封装已统一显示错误提示，失败时只清空模式并禁止保存。
              this.mode = '';
              return _context.a(2, false);
            case 4:
              _context.p = 4;
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function loadConfig() {
        return _loadConfig.apply(this, arguments);
      }
      return loadConfig;
    }(),
    mapConfigToForm: function mapConfigToForm(data) {
      if (!data) return createDefaultForm();
      return {
        sendTypes: this.parseSendTypes(data.sendType),
        rechargeAmountThreshold: data.rechargeAmountThreshold === null || data.rechargeAmountThreshold === undefined || data.rechargeAmountThreshold === '' ? undefined : Number(data.rechargeAmountThreshold),
        noticeStatus: Number(data.noticeStatus) === 0 ? 0 : 1,
        auditorFeishuUserId: data.auditorFeishuUserId || '',
        submitterFeishuUserId: data.submitterFeishuUserId || '',
        noticeTime: data.noticeTime || ''
      };
    },
    parseSendTypes: function parseSendTypes(sendType) {
      if (!sendType) return [];
      return _toConsumableArray(new Set(String(sendType).split(',').map(function (item) {
        return Number(item);
      }).filter(function (item) {
        return Number.isFinite(item);
      }))).sort(function (a, b) {
        return a - b;
      });
    },
    handleRechargeAmountKeydown: function handleRechargeAmountKeydown(event) {
      var allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
      if (event.ctrlKey || event.metaKey || allowedKeys.includes(event.key) || /^\d$/.test(event.key)) {
        return;
      }
      if (event.key === '.' && event.target.value && !event.target.value.includes('.')) {
        return;
      }
      event.preventDefault();
    },
    handleRechargeAmountPaste: function handleRechargeAmountPaste(event) {
      var pastedText = event.clipboardData.getData('text');
      var input = event.target;
      var nextValue = "".concat(input.value.slice(0, input.selectionStart)).concat(pastedText).concat(input.value.slice(input.selectionEnd));
      if (!/^\d{0,10}(\.\d{0,2})?$/.test(nextValue)) {
        event.preventDefault();
      }
    },
    validateRechargeAmount: function validateRechargeAmount(rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        callback();
        return;
      }
      var amount = Number(value);
      if (!Number.isFinite(amount) || amount < 0) {
        callback(new Error('审核金额不能小于0'));
        return;
      }
      if (amount > 9999999999.99 || !/^\d{1,10}(\.\d{1,2})?$/.test(String(value))) {
        callback(new Error('审核金额最多支持10位整数和2位小数'));
        return;
      }
      callback();
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      if (this.submitting || this.loading || !this.mode) return;
      if (this.resetNegativeRechargeAmount()) return;
      this.$refs.auditConfigFormRef.validate(function (valid) {
        if (!valid) return;
        _this2.saveConfig();
      });
    },
    resetNegativeRechargeAmount: function resetNegativeRechargeAmount() {
      var _this3 = this;
      var amount = this.form.rechargeAmountThreshold;
      if (amount === null || amount === undefined || amount === '' || Number(amount) >= 0) {
        return false;
      }
      this.form.rechargeAmountThreshold = 0;
      this.$message.error('充值总金额不能小于0，已重置为0.00，本次未保存');
      this.$nextTick(function () {
        if (_this3.$refs.auditConfigFormRef) {
          _this3.$refs.auditConfigFormRef.clearValidate('rechargeAmountThreshold');
        }
      });
      return true;
    },
    saveConfig: function () {
      var _saveConfig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var isCreateMode, payload, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!this.submitting) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              isCreateMode = this.mode === 'create';
              payload = this.buildPayload();
              this.submitting = true;
              _context2.p = 2;
              if (!isCreateMode) {
                _context2.n = 4;
                break;
              }
              _context2.n = 3;
              return (0, _api.addRechargeAuditConfig)(payload);
            case 3:
              _context2.n = 5;
              break;
            case 4:
              _context2.n = 5;
              return (0, _api.updateRechargeAuditConfig)(payload);
            case 5:
              this.$message.success(isCreateMode ? '配置创建成功' : '配置修改成功');
              _context2.n = 6;
              return this.loadConfig();
            case 6:
              _context2.n = 8;
              break;
            case 7:
              _context2.p = 7;
              _t2 = _context2.v;
              if (!(isCreateMode && this.isConfigExistsError(_t2))) {
                _context2.n = 8;
                break;
              }
              _context2.n = 8;
              return this.loadConfig();
            case 8:
              _context2.p = 8;
              this.submitting = false;
              return _context2.f(8);
            case 9:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 7, 8, 9]]);
      }));
      function saveConfig() {
        return _saveConfig.apply(this, arguments);
      }
      return saveConfig;
    }(),
    buildPayload: function buildPayload() {
      var sendType = _toConsumableArray(new Set(this.form.sendTypes.map(function (item) {
        return Number(item);
      }))).sort(function (a, b) {
        return a - b;
      }).join(',');
      var amount = this.form.rechargeAmountThreshold;
      return {
        sendType: sendType,
        rechargeAmountThreshold: amount === '' || amount === null || amount === undefined ? null : Number(amount),
        noticeStatus: this.form.noticeStatus,
        auditorFeishuUserId: this.trimToNull(this.form.auditorFeishuUserId),
        submitterFeishuUserId: this.trimToNull(this.form.submitterFeishuUserId),
        noticeTime: this.form.noticeTime || null
      };
    },
    trimToNull: function trimToNull(value) {
      var result = value ? String(value).trim() : '';
      return result || null;
    },
    isConfigExistsError: function isConfigExistsError(error) {
      var message = error && (error.message || error.msg);
      return String(message || '').includes('配置已存在');
    }
  }
};